import React, { useContext, useEffect, useRef, useState } from 'react';
import { Badge, Button, Modal, OverlayTrigger, Popover } from 'react-bootstrap';
import {
  deactivateModule,
  levelsActivate,
  levelsAffectedUsers,
} from '../../../../../../../services/endpoints/settings';
import Spinner from '../../../../../../../components/Loaders/Spinner';
import { Context } from '..';
import {
  CHANGE_VIEW,
  LIST,
} from '../reducer/actionTypes';
import AlertComponent from '../../../../../../../components/Alert';
import { getName } from '../../helpers';
import { delay, getErrorMessage } from '../../../../../../../utils/helper';
import Loader from '../../../../../../../components/Loaders/Loader';

const ViewActivation = () => {
  const [state, contextDispatch] = useContext(Context)
  const { default_language_code, levels, onSubmit, onHide, access } = state;
  let ref = useRef(null);
  const [data, setData] = useState({
    isLoading: false,
    isLoadingAffected: true,
    userSpent: {},
    error: null,
    success: false,
  })

  const { isLoading, isLoadingAffected, success, userSpent, error } = data;

  const onActivate = async (e) => {
    e.preventDefault();
    setData((prevState) => ({
      ...prevState,
      isLoading: true,
    }))
    try {
      await levelsActivate({
        levels,
      })
      setData((prevState) => ({
        ...prevState,
        success: true,
      }))
      await delay(500)
      onSubmit()
    } catch (error) {
      const errorMessage = getErrorMessage(error)
      setData((prevState) => ({
        ...prevState,
        isLoading: false,
        error: errorMessage,
      }))
    }
  }

  const affectedUsers = async () => {
    try {
      const response = await levelsAffectedUsers({
        total_user_spent: levels.map((level) => level.total_spent),
      })
      setData((prevState) => ({
        ...prevState,
        userSpent: response.data,
        isLoadingAffected: false,
        error: null,
      }))
    } catch (error) {
      const errorMessage = getErrorMessage(error)
      setData((prevState) => ({
        ...prevState,
        error: errorMessage,
      }))
    }
  }

  const onDeactivate = async () => {
    ref?.handleHide()
    setData((prevState) => ({
      ...prevState,
      isLoading: true,
    }))
    try {
      await deactivateModule(state.data.id);
      setData((prevState) => ({
        ...prevState,
        success: true,
      }))
      await delay(500);
      onSubmit()
    } catch (error) {
      const errorMessage = getErrorMessage(error)
      setData((prevState) => ({
        ...prevState,
        isLoading: false,
        success: false,
        error: errorMessage,
      }))
    }
  }

  useEffect(() => {
    affectedUsers()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onBack = () => {
    contextDispatch({
      type: CHANGE_VIEW,
      payload: {
        view: LIST,
      },
    })
  }

  const popover = (
    <Popover id="popover-trigger-click-root-close" title="" className="text-center">
      <Button bsStyle="primary" bsSize="sm" onClick={onDeactivate}>Confirm</Button>
      <Button bsSize="sm" className="ml-8" onClick={() => ref?.handleHide()}>Cancel</Button>
    </Popover>
  );

  return (
    <>
      <form onSubmit={onActivate}>
        <Modal.Header closeButton onHide={onHide}>
          <Modal.Title>User level system: activation</Modal.Title>
        </Modal.Header>
        {isLoading && <Loader success={success} />}
        <Modal.Body>
          {error && <AlertComponent type="danger" text={error} />}
          <AlertComponent classNames="mb-0" type="warning" text="Discounts will apply to all users, except those with custom discounts. Review settings carefully, as edits or reactivation is allowed only once per hour." />
        </Modal.Body>
        <table className="table level-system__table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Discount, %</th>
              <th>Total user spent from</th>
              <th>Users</th>
            </tr>
          </thead>
          <tbody>
            {levels.map((level) => {
              const name = getName(level.name, default_language_code);

              return (
                <tr key={`level-${level.id}`}>
                  <td className="level-system__table-name">
                    <div className="level-system__level-name">
                      {name}
                      {' '}
                      {level.is_default && <Badge>Default</Badge>}
                    </div>
                  </td>
                  <td>
                    <span>{level.discount}</span>
                  </td>
                  <td>
                    <span>{level.total_spent}</span>
                  </td>
                  <td>
                    <div className="level-system__table-spent-user">
                      {isLoadingAffected && <Spinner />}
                      {userSpent[level.total_spent] || null}
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
        <Modal.Footer className="custom__modal-footer modal-footer">
          <Button
            type="submit"
            bsStyle="primary"
            disabled={isLoading || isLoadingAffected}
          >
            <span>{state.data.type === 'edit' ? 'Save changes' : 'Activate'}</span>
          </Button>
          <Button
            disabled={isLoading}
            onClick={onBack}
          >
            <span>Back</span>
          </Button>
          {state?.data?.type === 'edit' && access?.modules_deactivate ? (
            <div className="pull-right">
              <OverlayTrigger ref={(r) => (ref = r)} trigger="click" rootClose placement="top" overlay={popover}>
                <Button
                  disabled={isLoading}
                  bsStyle="link"
                  className="modal-delete-btn"
                >
                  Deactivate
                </Button>
              </OverlayTrigger>
            </div>
          ) : null}
        </Modal.Footer>
      </form>
    </>
  )
}

ViewActivation.propTypes = {};

export default ViewActivation;
